<template>
  <div class="sh-page">
    <!-- Same orbital treatment as the Metaship root's boot loader, in the
         tenant's colours with the tenant's mark at the centre. -->
    <OrbitalLoader :label="t('auth.completing')" />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import OrbitalLoader from "@/shell/OrbitalLoader.vue";
import { useSessionStore } from "@/stores/session";

export default defineComponent({
  name: "Callback",
  components: { OrbitalLoader },
  setup() {
    const { t } = useI18n();
    const session = useSessionStore();

    onMounted(async () => {
      // App.vue also shows this spinner for status "authenticating" on any
      // path (a silent resume, a Better Auth sign-in). Those flows own the
      // status. Only a real /auth0/callback page has a code to exchange, and
      // returnToLogin() below would cut the other flows off half-way.
      if (window.location.pathname !== "/auth0/callback") return;
      // Capture the callback's query string and clear the URL FIRST, before
      // any async work. `session.status` can flip to "ready" partway through
      // `completeAuth0Callback` (org auto-selected), which fires main.ts's
      // watcher — `singleSpa.navigateToUrl(homePath)` — synchronously ahead
      // of this function's continuation. Clearing the URL AFTER that point
      // used to overwrite the just-navigated-to home path with "/", landing
      // on an empty outlet. Doing it first means the URL is already clean by
      // the time anything reacts to the status change.
      const search = window.location.search;
      window.history.replaceState(null, "", "/");
      // No Auth0 query at all — this is a history/Back-button revisit of the
      // callback URL (or a hand-typed one), not a return from Auth0. Silently
      // land on the login screen instead of surfacing "No callback parameters
      // found in URL" as if sign-in had failed (seen on crm.* 2026-08-27
      // after users backed into the pre-fix stuck URL).
      const params = new URLSearchParams(search);
      if (!params.has("code") && !params.has("error")) {
        session.returnToLogin();
        return;
      }
      try {
        await session.completeAuth0Callback(search);
      } catch (e) {
        // Login.vue renders `session.errorMessage` — App.vue swaps to it
        // automatically once `status` leaves "authenticating".
        session.fail(e instanceof Error ? e.message : "Authentication failed");
      }
    });

    return { t };
  },
});
</script>

<!-- `.sh-page` (src/styles/standalone.css) is the shared full-page frame. -->
